import React, { useState } from "react";
import { TreeSelect } from "antd";

const { SHOW_PARENT } = TreeSelect;

export default function TreeSelection({
  treeData = [],
  onChange,
  value,
  placeholder = "Please Select",
}) {
  const tProps = {
    treeData,
    value,
    onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: placeholder,
    dropdownStyle: { zIndex: 9999, maxHeight: 400, overflow: "auto" },
    style: {
      width: "100%",
    },
  };

  return <TreeSelect {...tProps} />;
}
